

export class getListCSBO {
    agencyId: string;
    clientId: string | null;
    employeeId: string | null;
    startDate: string | null;
    endDate: string | null;
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "clientName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "clientName";
    operator: string = "contains";
    value: string = "";
    matchCase: boolean = false;
    userId: string | null;
    isExported:string="unexported";

}

export class EngementBO {
    id: string;
    engementId: string;
    callStartDate: string;
    callEndDate: string;
    clientId: string;
    clientName: string;
    channel: string;
    queueName: string;
    duration: number;
    dispositionName: string;
    note: string;
    callRecording: string;
    chatTranscript: string;
    containerName: string;
    cfsAgencyId: string;
    userId: string;
    userName: string;
    sessionFileString: string;
    sessionFormName: string;
    sessionFormPath: string;
    typeofContact: string;
    typeofSession: string;
    serviceCode:string;
}

export class SessionFormSaveBO {
    engagementId: string;
    dynamicFormTemplateId: string;
    file: any;
}

export class GenerateDynamicSessionFormBO {
    engementId: string;
    templateId: string;
    sessionFormId: string;
}

export class ClientTabBO
{
    ClientId:string
}

export class EmitBo{
    EngagementId:string="00000000-0000-0000-0000-000000000000"
    byteArray:any;
    FormTemplateId:string="00000000-0000-0000-0000-000000000000";
    isChild:boolean=false
    sessionFormId: string="00000000-0000-0000-0000-000000000000";
    isUpdateForm:boolean=false;
}

export class Filteroptions{
    clientId:string;
    userId:string;
    startDate:any;
    endDate:any;
}
export class EngagementSaveBO {
    id: string="00000000-0000-0000-0000-000000000000";
    engementId: string;
    callStartDate: string;
    callEndDate: string;
    clientId: string;
    clientName: string;
    channel: string;
    queueName: string;
    duration: number | null;
    userId: string;
    employeeId: string;
    userName: string;
    typeofContactId: string;
    contactDescribe: string;
    typeofServiceId: string;
    pMI: string ;
    descriptionOfSessionAndOutcome: string | null;
    sessionTypeList: EngagementServiceType[];
    serviceType  :string;
    contactType:string;
    serviceCode :string
}
export class EngagementServiceType {
    engagementId: string="00000000-0000-0000-0000-000000000000";
    serviceTypeId: string;
    serviceListLovid: string;
    isCheck: boolean;
    description: string;
}

export class Authpopup{
    clientId :string="00000000-0000-0000-0000-000000000000";
    startDate :string ;
    endDate : string;
}
export class ClientAuthforSessionBO {
    id: string="00000000-0000-0000-0000-000000000000";
    clientId: string;
    startDate: Date | string;
    endDate: Date | string;
}

export class functionpermission {
    isEmployeeEnable: boolean = true;

}